export const getCreditCardVendor = (value) => {
  if (/^5[1-5]/.test(value) && value.length === 16) {
    return 'CA';
  } else if (/^4/.test(value) && value.length === 16) {
    return 'VI';
  } else if (/^3[47]/.test(value) && value.length === 15) {
    return 'AX';
  } else if (/^(?:3(?:0[0-5]|[68][0-9])[0-9]{11})$/.test(value) && value.length === 14) {
    return 'DC';
  } else if (
    /^(35(?:[2-8][8-9])\d{11,12})$/.test(value) &&
    (value.length === 15 || value.length === 16)
  ) {
    return 'JC';
  } else if (/^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/.test(value)) {
    return 'DS';
  } else {
    return null;
  }
};

export function sponsoredTravelCreditCardsData(params) {
  let sponsoredCards = {};
  const isAHC =
    params?.isAir &&
    params?.isAirSponsoredTravel &&
    params?.isHotel &&
    params?.isHotelSponsoredTravel &&
    params?.isCar &&
    params?.isCarSponsoredTravel;
  const isAirHotel =
    params?.isAir &&
    params?.isAirSponsoredTravel &&
    params?.isHotel &&
    params?.isHotelSponsoredTravel;
  const isAirCar =
    params?.isAir && params?.isAirSponsoredTravel && params?.isCar && params?.isCarSponsoredTravel;
  const isHotelCar =
    params?.isHotel &&
    params?.isHotelSponsoredTravel &&
    params?.isCar &&
    params?.isCarSponsoredTravel;
  if (isAHC) {
    sponsoredCards = {
      isAirSponsoredTravel: params?.isAirSponsoredTravel,
      getDefaultAirCardKey: params?.getDefaultAirCardKey,
      isHotelSponsoredTravel: params?.isHotelSponsoredTravel,
      getDefaultHotelCardKey: params?.getDefaultHotelCardKey,
      isCarSponsoredTravel: params?.isCarSponsoredTravel,
      getDefaultCarCardKey: params?.getDefaultCarCardKey,
    };
  } else if (isAirHotel) {
    sponsoredCards = {
      isAirSponsoredTravel: params?.isAirSponsoredTravel,
      getDefaultAirCardKey: params?.getDefaultAirCardKey,
      isHotelSponsoredTravel: params?.isHotelSponsoredTravel,
      getDefaultHotelCardKey: params?.getDefaultHotelCardKey,
    };
  } else if (isAirCar) {
    sponsoredCards = {
      isAirSponsoredTravel: params?.isAirSponsoredTravel,
      getDefaultAirCardKey: params?.getDefaultAirCardKey,
      isCarSponsoredTravel: params?.isCarSponsoredTravel,
      getDefaultCarCardKey: params?.getDefaultCarCardKey,
    };
  } else if (isHotelCar) {
    sponsoredCards = {
      isHotelSponsoredTravel: params?.isHotelSponsoredTravel,
      getDefaultHotelCardKey: params?.getDefaultHotelCardKey,
      isCarSponsoredTravel: params?.isCarSponsoredTravel,
      getDefaultCarCardKey: params?.getDefaultCarCardKey,
    };
  } else if (params?.isAir && params?.isAirSponsoredTravel) {
    sponsoredCards = {
      isAirSponsoredTravel: params?.isAirSponsoredTravel,
      getDefaultAirCardKey: params?.getDefaultAirCardKey,
    };
  } else if (params?.isAirExtra && params?.isAirExtraSponsoredTravel) {
    sponsoredCards = {
      isAirExtraSponsoredTravel: params?.isAirExtraSponsoredTravel,
      getDefaultAirExtraCardKey: params?.getDefaultAirExtraCardKey,
    };
  } else if (params?.isHotel && params?.isHotelSponsoredTravel) {
    sponsoredCards = {
      isHotelSponsoredTravel: params?.isHotelSponsoredTravel,
      getDefaultHotelCardKey: params?.getDefaultHotelCardKey,
    };
  } else if (params?.isCar && params?.isCarSponsoredTravel) {
    sponsoredCards = {
      isCarSponsoredTravel: params?.isCarSponsoredTravel,
      getDefaultCarCardKey: params?.getDefaultCarCardKey,
    };
  } else if (params?.isRail && params?.isRailSponsoredTravel) {
    sponsoredCards = {
      isRailSponsoredTravel: params?.isRailSponsoredTravel,
      getDefaultRailCardKey: params?.getDefaultRailCardKey,
    };
  } else {
    sponsoredCards = {};
  }
  return sponsoredCards;
}

export const componentTypeCreditCardNumber = {
  EMPTY: 0,
  AIR: 1,
  AIREXTRA: 2,
  HOTEL: 3,
  CAR: 4,
  RAIL: 5,
};
export const VirtualPaymentMessageForMsite =
  'This card used is a Virtual Card - please download the TripEasy Business Travel application from the Apple or Android app store to ensure you have access to the card information at check-in. ';
export function showVirtualPaymentMessageForMsite(isMsite, VirtualPaymentComponentTypes, type) {
  if (isMsite && VirtualPaymentComponentTypes?.length > 0) {
    const message = VirtualPaymentComponentTypes?.map((component) =>
      component === type ? VirtualPaymentMessageForMsite : ''
    );
    return message;
  } else {
    return '';
  }
}

export const getCreditCardVendorName = (travelCart, values) => {
  for (let i = 0; i < travelCart.CreditCardProviders.length; i++) {
    if (travelCart.CreditCardProviders[i].CreditCardVendorCode === values.hotel.ccProvider) {
      return travelCart.CreditCardProviders[i].CreditCardVendor;
    }
  }
  return null;
};
